/** As palavras da situação do posto: o chip e o filtro da lista falam igual. */
import type { ErgonomicSituation } from '../../types/ergonomicWorkstation';

export const SITUATION_LABELS: Record<ErgonomicSituation, string> = {
  EM_CADASTRO: 'Em cadastro',
  ACOES_EM_ABERTO: 'Ações em aberto',
  CONCLUIDO: 'Concluído',
};

export const INACTIVE_LABEL = 'Inativo';
